import script from "./PodcastShowsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastShowsList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__